import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import App from './app/app';
import './main.scss';

const el = document.getElementById('root');
if (!el) throw new Error('Unsupported browser');
const root = ReactDOM.createRoot(el);
root.render(
	<StrictMode>
		<App />
	</StrictMode>
);
